import { aspenApi as api, getVenturePosition } from "@aspen/services";
import { generateDataCacheKey } from "@aspen/libs";
import { useQuery } from "@tanstack/react-query";

/**
 * 获取venture产品持仓。
 */
export const useFetchVenturePositions = () => {
  const apiPath = api.ventures.venturePosition;
  const queryKey = generateDataCacheKey({ api: apiPath, params: "" });

  const { error, data, isLoading, refetch, isFetching } = useQuery({
    queryKey: [queryKey],
    queryFn: () => {
      return getVenturePosition().then(res => {
        return res;
      });
    },
  });
  return { error, data, refetch, queryKey, isLoading, isFetching };
};
